import React, { useState, useEffect } from 'react';
import './App.css';
import RegisterForm from './components/RegisterForm';
import FighterList from './components/FighterList';

function App() {
    const [view, setView] = useState('loading'); 
    const [fighterCount, setFighterCount] = useState(null);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        const tgUser = tg?.initDataUnsafe?.user;

        // Fetch live fighter count
        fetch('/api/fighter-count')
            .then(res => res.json())
            .then(data => setFighterCount(data.count))
            .catch(() => setFighterCount(0));

        if (!tgUser) {
            setView('public');
        } else {
            tg.expand();
            fetch(`/api/user-status?tg_id=${tgUser.id}`)
                .then(res => res.json())
                .then(data => {
                    setUser(data);
                    setView(data.role); 
                })
                .catch(() => setView('guest'));
        }
    }, []);

    const handleSignupSuccess = (name) => {
        setUser({ name });
        setView('registered');
        setFighterCount(prev => prev + 1);
    };

    if (view === 'loading') return <div className="loader">CONNECTING...</div>;

    return (
        <div className="App">
            <div className="top-nav"><div className="brand-main">Y FIGHT</div></div>

            <div className="container">
                <h1>50 MAN<br />KUMITE</h1>
                <div className="tagline">Kyokushin Rules • Nørrebrohallen</div>

                <div className="info-box">
                    <div className="info-item"><div className="label">Date</div><div className="value">27 March</div></div>
                    <div className="info-item"><div className="label">Time</div><div className="value">17:00</div></div>
                    <div className="info-item">
                        <div className="label">Fighters</div>
                        <div className="value">{fighterCount !== null ? `${fighterCount} / 50` : '...'}</div>
                    </div>
                </div>

                {/* --- PUBLIC VIEW (yfight.com) --- */}
                {view === 'public' && (
                    <>
                        {/* 1. Registration Box (Equal rendering, hidden spacer instead of barcode) */}
                        <div className="action-row">
                            <div className="qr-small" style={{ visibility: 'hidden' }}></div>
                            <div className="cta-text">
                                <p>Event Registration</p>
                                <a href="https://t.me/y_fight_bot" className="btn-link">
                                    Telegram Registration
                                </a>
                            </div>
                        </div>

                        {/* 2. Community Chat Box (Original rendering with qr-link.jpeg) */}
                        <div className="action-row">
                            <div className="qr-small">
                                <img src="/qr-link.jpeg" alt="Community Link" />
                            </div>
                            <div className="cta-text">
                                <p>Official Channel</p>
                                <a href="https://t.me/y_fight" className="btn-link">
                                    Y Fight Community Chat
                                </a>
                            </div>
                        </div>
                    </>
                )}

                {/* --- TELEGRAM: NEW VISITOR --- */}
                {view === 'guest' && (
                    <RegisterForm onSignupSuccess={handleSignupSuccess} />
                )}

                {/* --- TELEGRAM: REGISTERED FIGHTER --- */}
                {view === 'registered' && (
                    <div className="success-zone">
                        <p className="status-msg" style={{ marginBottom: '2rem', color: '#888', fontSize: '0.8rem', textTransform: 'uppercase' }}>
                            WELCOME, {user?.name?.split(' ')[0]}. YOUR ENTRY IS CONFIRMED.
                        </p>
                        <div className="action-row">
                            <div className="qr-small">
                                <img src="/qr-link.jpeg" alt="Community Link" />
                            </div>
                            <div className="cta-text">
                                <p>Official Channel</p>
                                <a href="https://t.me/y_fight" className="btn-link">
                                    Y FIGHT COMMUNITY CHAT
                                </a>
                            </div>
                        </div>
                    </div>
                )}

                {/* --- TELEGRAM: ADMINISTRATOR PANEL --- */}
                {view === 'admin' && (
                    <div className="admin-zone success-fade-in">
                        <div className="admin-header" style={{ color: 'var(--primary)', fontWeight: 'bold', marginBottom: '1rem', textAlign: 'left', fontSize: '0.8rem' }}>
                            ADMINISTRATOR ACCESS
                        </div>
                        <FighterList />
                    </div>
                )}

                <div className="footer">Powered by <a href="https://ensopeople.org">Enso People</a></div>
            </div>
        </div>
    );
}

export default App;